import React from "react";
import moment from "moment";
import { FormSection } from "../FormBits";
import { newestFirst } from "./notes/noteBits";

// Same extension sniffing as Warranties/SingleWarranty/Activities/NoteItem.
const getMediaKind = function (url) {
  const lower = (url || "").toLowerCase();
  if (lower.includes(".jpg") || lower.includes(".jpeg") || lower.includes(".png")) return "image";
  if (lower.includes(".mp4") || lower.includes(".mov") || lower.includes(".webm")) return "video";
  if (lower.includes(".pdf")) return "pdf";
  return null;
};

export const ActivityMedia = function (props) {
  const media = props.media;
  return (
    <div className={"tn-timeline-media" + (media.length > 1 ? " tn-timeline-media-grid" : "")}>
      {media.map(function (item, idx) {
        const url = item.media;
        const kind = getMediaKind(url);
        if (kind === "image")
          return (
            <a key={idx} href={url} target="_blank" rel="noopener noreferrer">
              <img src={url} alt={url.split("/").pop()} loading="lazy" />
            </a>
          );
        if (kind === "video")
          return (
            <video key={idx} controls>
              <source src={url} type="video/mp4" />
              <source src={url} type="video/webm" />
              <source src={url} type="video/quicktime" />
              <source src={url} type="video/x-quicktime" />
            </video>
          );
        if (kind === "pdf")
          return <iframe key={idx} src={url} title={url.split("/").pop()} />;
        return null;
      })}
    </div>
  );
};

// Mirrors the warranty Activities feed: notes carry HTML `detail` or
// `list_media`, plain activities carry text `detail`, and communications
// carry HTML in `note`.
const ActivityContent = function (props) {
  const entry = props.entry;
  if (entry.list_media && entry.list_media.length) {
    return <ActivityMedia media={entry.list_media} />;
  }
  if (entry.activity_type === "activity") {
    return entry.detail ? <div className="tn-timeline-detail">{entry.detail}</div> : null;
  }
  const html = entry.activity_type === "communication" ? entry.note : entry.detail;
  return html ? (
    <div className="tn-timeline-detail" dangerouslySetInnerHTML={{ __html: html }} />
  ) : null;
};

// GET /ticket/{id}/'s `ticket_activities[]` - already timestamped, so no
// mapping onto the mock's fixed label set is needed. Shown newest first.
const ActivityLogTab = function (props) {
  const activities = newestFirst(props.ticket && props.ticket.ticket_activities);

  return (
    <div className="tn-tabpanel">
      <FormSection title="Activity Log">
        {activities.length ? (
          <ol className="tn-timeline">
            {activities.map(function (entry, index) {
              const when = entry.created ? moment(entry.created) : null;
              const title =
                entry.activity_type === "communication"
                  ? "Communication by " + (entry.created_by || "—")
                  : entry.subject;
              return (
                <li className="tn-timeline-item" key={entry.id || index}>
                  <div className="tn-timeline-rail">
                    <span className="tn-timeline-dot tn-timeline-dot-done" />
                    {index < activities.length - 1 ? (
                      <span className="tn-timeline-line" />
                    ) : null}
                  </div>
                  <div className="tn-timeline-body">
                    {title ? <div className="tn-timeline-label">{title}</div> : null}
                    <ActivityContent entry={entry} />
                    <div className="tn-timeline-value tn-mono">
                      {when && when.isValid()
                        ? when.format("DD MMM YYYY · HH:mm")
                        : "—"}
                      {entry.created_by ? " · " + entry.created_by : ""}
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        ) : (
          <div className="tn-empty">No activity recorded yet.</div>
        )}
      </FormSection>
    </div>
  );
};

export default ActivityLogTab;
